export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7454.a924f499.jpg";